<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
        <path d="M5.64645 0.503161C5.84171 0.307899 6.15829 0.3079 6.35355 0.503162L10.65 4.79961C10.8433 4.99291 10.8433 5.30631 10.65 5.49961C10.4567 5.69291 10.1433 5.69291 9.95 5.49961L6.35355 1.90316C6.15829 1.7079 5.84171 1.7079 5.64645 1.90316L2.05 5.49961C1.8567 5.69291 1.5433 5.69291 1.35 5.49961C1.1567 5.30631 1.1567 4.99291 1.35 4.79961L5.64645 0.503161Z" fill="#2168BC" stroke="#2168BC" stroke-width="0.5" stroke-linejoin="round"/>
    </svg>
</template>
<script>
const chevronUpIcon = {
    name: 'chevronUpIcon',
}
export default chevronUpIcon
export { chevronUpIcon }
</script>
